import { Icon } from '@chakra-ui/react';
import {
  MdLock
} from 'react-icons/md';

// Admin Imports

// Auth Imports
import SignInPage from 'views/auth/signIn';
import AcceptInvitationPage from '../features/auth/AcceptInvitationPage';
import ForgotPasswordPage from '../features/auth/ForgotPasswordPage';
import SignUpPage from '../features/auth/SignUpPage';
import { RType } from './types';

const authRoutes: RType[] = [
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    hidden: true,
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInPage />,
  },
  {
    name: 'Sign Up',
    layout: '/auth',
    path: '/sign-up',
    hidden: true,
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignUpPage />,
  },
  {
    name: 'Forgot Password',
    layout: '/auth',
    path: '/forgot-password',
    hidden: true,
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <ForgotPasswordPage />,
  },
  {
    name: 'Accept Invitation',
    layout: '/auth',
    path: '/sign-in/accept-invitation',
    hidden: true,
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <AcceptInvitationPage />,
  },
];
export default authRoutes;
